<svg
  width="24"
  height="32"
  viewBox="0 0 24 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0 4C0 1.79063 1.78656 0 3.99093 0H14.3112C15.3713 0 16.3815 0.421438 17.1298 1.17188L22.7795 6.83125C23.5278 7.58125 23.9456 8.59375 23.9456 9.65625V28C23.9456 30.2062 22.1559 32 19.9546 32H3.99093C1.78656 32 0 30.2062 0 28V4ZM20.9524 28V10H15.9637C14.86 10 13.9683 9.10625 13.9683 8V3H3.99093C3.43968 3 2.9932 3.4475 2.9932 4V28C2.9932 28.55 3.43968 29 3.99093 29H19.9546C20.5034 29 20.9524 28.55 20.9524 28Z"
    fill="var(--color-icon-secondary)" />
</svg>
